import React from "react";

function InputSelect({
  name,
  className,
  label,
  onChange,
  value,
  required,
  isDisable,
  errors,
  errormessage,
  option,
}: any) {
  return (
    <div className={"form__group"}>
      <label htmlFor="" className={`${className} form__label`}>
        {label}
      </label>
      <select
        id="dropdown"
        onChange={onChange}
        value={value}
        required={required ?? false}
        className={`form__field ${errors ? "mandatory_input" : ""}`}
        disabled={isDisable}
        name={name}
      >
        <option value="">Select an option</option>
        {option?.map((item: any, index: number) => (
          <option key={index} value={item?.value}>
            {item?.name}
          </option>
        ))}
      </select>
      {errors && (
        <label className="form__label__error">
          {errormessage
            ? errormessage
            : `${label ? label : "this feild"} is mandatory`}
        </label>
      )}
    </div>
  );
}

export default InputSelect;
